import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { mapTo, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private ngZone: NgZone) {
    // Listen to browser online/offline events
    // Use NgZone.runOutsideAngular to avoid triggering change detection too often
    fromEvent(window, 'online').subscribe(() => this.setOnline(true));
    fromEvent(window, 'offline').subscribe(() => this.setOnline(false));
  }

  private setOnline(value: boolean) {
    // Ensure changes run inside Angular zone when emitting
    this.ngZone.run(() => this.online$.next(value));
  }

  get isOnline$(): Observable<boolean> {
    return this.online$.asObservable();
  }
}
